<p>{{ '4_POSSIBLE_STATES' | transloco }}</p>
<ul>
  <li>
    <mat-icon class="connection-indicator pastel-green">brightness_1</mat-icon>
    <div>{{ 'FUNCTIONAL' | transloco }}</div>
  </li>
  <li>
    <mat-icon class="connection-indicator blue-zodiac">brightness_1</mat-icon>
    <div>{{ 'PRESUMED_NON_COMMUNICATING' | transloco }}</div>
  </li>
  <li>
    <mat-icon class="connection-indicator cornflower">brightness_1</mat-icon>
    <div>{{ 'PRESUMED_OUT_OF_SERVICE' | transloco }}</div>
  </li>
  <li>
    <mat-icon class="connection-indicator grey">brightness_1</mat-icon>
    <div>{{ 'UNKNOWN' | transloco }}</div>
  </li>
</ul>
